import {NgModule} from '@angular/core';


import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TextEditorComponent} from './text-editor/text-editor.component';
import {AirportEditorComponent} from './airport-editor/airport-editor.component';
import {CityEditorComponent} from './city-editor/city-editor.component';
import {CountryEditorComponent} from './country-editor/country-editor.component';
import {DateEditorComponent} from './date-editor/date-editor.component';
import {CivilityEditorComponent} from './civility-editor/civility-editor.component';
import {PhoneEditorComponent} from './phone-editor/phone-editor.component';
import {OperatorEditorComponent} from './operator-editor/operator-editor.component';
import {SetNullEditorComponent} from './set-null-editor/set-null-editor.component';
import {TranslateModule} from '@ngx-translate/core';
import {DropdownModule} from 'primeng/dropdown';
import {RippleModule} from 'primeng/ripple';
import {DynamicEditorDirective} from './dynamic-editor.directive';
import {CheckboxModule} from 'primeng/checkbox';
import {DatePickerModule} from 'primeng/datepicker';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {BooleanEditorComponent} from './boolean-editor/boolean-editor.component';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {ChipsModule} from 'primeng/chips';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputNumberModule} from "primeng/inputnumber";
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import { ProductTypeEditorComponent } from './product-type-editor/product-type-editor.component';
import { CurrentTypeEditorComponent } from './current-type-editor/current-type-editor.component';
import { ProviderEditorComponent } from './provider-editor/provider-editor.component';

const list = [
    TextEditorComponent,
    AirportEditorComponent,
    CityEditorComponent,
    CountryEditorComponent,
    DateEditorComponent,
    CivilityEditorComponent,
    ProductTypeEditorComponent,
    PhoneEditorComponent,
    OperatorEditorComponent,
    SetNullEditorComponent,
    DynamicEditorDirective,
    BooleanEditorComponent,
    CurrentTypeEditorComponent,
    ProviderEditorComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        DropdownModule,
        RippleModule,
        CheckboxModule,
        DatePickerModule,
        AutoCompleteModule,
        ToggleButtonModule,
        ChipsModule,
        InputSwitchModule,
        ReactiveFormsModule,
        InputNumberModule,
        InputTextModule,
        ButtonModule
    ],
    declarations: [
        ...list
    ],
    exports: [
        ...list
    ]
})
export class EditorModule {
}
